import React, { createContext, useContext, useState, useEffect } from 'react';
import { supabase } from '../utils/supabase';

const SeasonContext = createContext();

export function SeasonProvider({ clubId, children }) {
  const [season, setSeason] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchSeason() {
      setLoading(true);
      if (!clubId) {
        setSeason(null);
        setLoading(false);
        return;
      }
      const { data, error } = await supabase
        .from('seasons')
        .select('*')
        .eq('club_id', clubId)
        .eq('season_status', 'current')
        .maybeSingle(); // Use maybeSingle() instead of single() to avoid 406 error
      
      if (error) {
        console.error('Error fetching current season:', error);
      }
      
      if (!data) {
        console.warn('No current season found for club:', clubId);
        // Fallback: get the latest season by season_number (most recent)
        const { data: fallbackData, error: fallbackError } = await supabase
          .from('seasons')
          .select('*')
          .eq('club_id', clubId)
          .order('season_number', { ascending: false })
          .limit(1)
          .maybeSingle();
        
        if (fallbackData) {
          console.log('Using fallback season:', fallbackData);
          setSeason(fallbackData);
        } else {
          console.warn('No seasons found for club:', clubId);
          setSeason(null);
        }
      } else {
        console.log('Found current season:', data);
        setSeason(data);
      }
      
      setLoading(false);
    }
    fetchSeason();
  }, [clubId]);

  return (
    <SeasonContext.Provider value={{ season, loading, setSeason }}>
      {children}
    </SeasonContext.Provider>
  );
}

export function useSeason() {
  return useContext(SeasonContext);
} 